import Component from './component';

const OpenHouseModal = (props) => <Component {...props} />;

export default OpenHouseModal;

export { Component as component };
